import React, { forwardRef } from 'react'
import classNames from 'classnames'

import foxImage from './foxImage.webp'

type SizeType = 's' | 'l' | 'xl'

const sizeToStyle: Record<SizeType, string> = {
  s: 'w-8 h-8',
  l: 'w-20 h-20',
  xl: 'w-28 h-28'
}

const sizeToRadius: Record<SizeType, string> = {
  s: 'rounded',
  l: 'rounded-lg',
  xl: 'rounded-xl'
}

export type ActivityImage = Omit<React.HTMLProps<HTMLImageElement>, 'src' | 'size'> & {
  url?: string | null
  size?: SizeType
}

/**
 * @group Components
 * @category Component
 */
export const ActivityImage = forwardRef(
  ({ className, url, size = 's', ...restProps }: ActivityImage, ref: React.Ref<HTMLImageElement>) => {
    const src = url || (foxImage as unknown as string)
    const sizeStyle = sizeToStyle[size]
    const radiusStyle = sizeToRadius[size]

    return (
      <img
        ref={ref}
        src={src}
        alt="ActivityImage"
        className={classNames('object-cover', sizeStyle, radiusStyle, className)}
        {...restProps}
      />
    )
  }
)

ActivityImage.displayName = 'ActivityImage'
